const rqParams = {
  getbookstudyrecordlist(param) {
    return {
      op_path: 'exercisebook.book.getbookstudyrecordlist',
      ...param
    }
  },
  // 根据产品id和书本类型获取书本列表
  getbooklistbyproductidandtype(param) {
    return {
      op_path: 'resource.book.getbooklistbyproductidandtype',
      ...param
    }
  },
  /**
   * 根据基本信息获取对应书本的简单信息
   */
  getUserPracticeRecordList(params) {
    return {
      op_path: 'resource.informationcontent.getinformationpublishcontentbyid',
      ...params
    }
  },
  /**
   * @description 教辅书数据概览
   * @param {*} params
   * @returns
   */
  getUserStudyStatisticsByBookid(params) {
    return {
      op_path:
        'yjstudyrecord.studyrecorddata.getuserstudystatisticsbybookid',
      noJumpTo: true,
      ...params
    }
  },
  /**
   * @description 班级数据概览
   * @param {*} params
   * @returns
   */
  getUserStudyStatisticsByClassid(params) {
    return {
      op_path:
        'yjstudyrecord.studyrecorddata.getuserstudystatisticsbyclassid',
      noJumpTo: true,
      ...params
    }
  },
  /**
   * @description 数据概览-教辅书-学习学生数和题目完成度
   * @param {*} params
   * @returns
   */
  getStudyRecordModelCountByBookId(params) {
    return {
      op_path:
        'yjstudyrecord.studyrecorddata.getstudyrecordmodelcountbybookid',
      ...params
    }
  },
  /**
   * @description 数据概览-班级数据详情
   * @param {*} params
   * @returns
   */
  getStudyClassStudentDetail(params) {
    return {
      op_path:
        'yjstudyrecord.studyrecorddata.getstudyclassstudentdetail',
      ...params
    }
  }
}
export default rqParams
